import { render } from "./FooterPIT.vue?vue&type=template&id=0b09567c&scoped=true"
import script from "./FooterPIT.vue?vue&type=script&lang=js"
export * from "./FooterPIT.vue?vue&type=script&lang=js"

import "./FooterPIT.vue?vue&type=style&index=0&id=0b09567c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3690218082/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b09567c"]])

export default __exports__